import React, { useContext } from 'react'
import { UserdataContext } from '../../../App'
import JobOffers from '../logged-area/job-offers'
import UnloggedOffers from '../unlogged-area/offers'

const OffersWrapper = () => {
  const { userData } = useContext(UserdataContext)
  
  // Se o usuário estiver logado como manager, renderiza a página de ofertas para managers
  if (userData && userData.usertype === 'job_manager') {
    return <JobOffers />
  }
  
  // Para candidatos logados e usuários não logados, renderiza a página de ofertas com cards
  return <UnloggedOffers />
}

export default OffersWrapper
